
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/baptism-by-fire-and-water",
      function () {
        return require("private-next-pages/baptism-by-fire-and-water/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/baptism-by-fire-and-water"])
      });
    }
  